var map = {
  "./cs.json": [
    "bIJ",
    [
      "h8"
    ]
  ],
  "./en.json": [
    "XWn",
    [
      "5d"
    ]
  ],
  "./pl.json": [
    "roz",
    [
      "txm"
    ]
  ],
  "./ru.json": [
    "FJj",
    [
      "jg"
    ]
  ],
  "./tr.json": [
    "hA",
    [
      "vg"
    ]
  ],
  "./ja.json": [
    "J45",
    [
      "f3"
    ]
  ],
  "./zh.json": [
    "wJ",
    [
      "mj"
    ]
  ],
  "./pt-br.json": [
    "jU",
    [
      96
    ]
  ],
  "./de.json": [
    "h8",
    [
      39
    ]
  ],
  "./es.json": [
    "YBg",
    [
      "ew9"
    ]
  ],
  "./fr.json": [
    "wgk",
    [
      "qh"
    ]
  ],
  "./it.json": [
    "UCN",
    [
      "it"
    ]
  ],
  "./ko.json": [
    "Il4",
    [
      "2b"
    ]
  ],
  "./pt.json": [
    "wa",
    [
      "y16"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "VZ";
module.exports = __rspack_async_context;
